import React from 'react';
import useSelector from 'hooks/useSelector';
import './LoadingSplash.css';


export const LoadingSplash = () => {
    const profile = useSelector(state => state.profile);

    return (
        <div className={`${profile === undefined ? "shown " : ""}loading-splash modal`}></div>
    );
}

export default LoadingSplash;
